/**
 * @Create idler.zhu(zqc.sunny@aliyun.com)
 * @CreateDate  2017/12/11
 */
import './index.css';
import PropTypes from 'prop-types';
import React, {Component} from 'react';
import { connect } from 'react-redux';
import SelectRow from '../selectRow';
import {getToEvaluateData} from '../../../reducers/step'
import Button from '../../lib/button';
import Loading from '../../common/loading';
import {setisLoading} from '../../../actions/app';

/**
 * 选择状态判断记录：
 * 1、propList 为回购网专有，返回时须回传至专有prop字段[x]
 * 2、oneList 区分回购网及爱回收
 *  * 回购网则为普通单选描述属性[x]
 *  * 爱回收则须搭配skus字段进行选项可选开启判断
 * 3、thrList 区分回购网及爱回收[x]
 *  * 回购网则须搭配childDescMap进行子集遍历，
 *    如当前条目选中子集在childDescMap中存在则须
 *    在其下方展示childDescMap对应条目（可能存在多条）[x]
 *  * 爱回收则为普通单选描述属性[x]
 * 4、twoList 为单多复合选择，panel面板展示为：功能问题[x]
 */
class Select extends Component {
  static contextTypes = {
    store: PropTypes.object.isRequired
  };
  state = {
    open: 0
  };
  handleOpenPanel = (index) => {
    this.setState(state => ({
      open: state.open === index ? -1 : index
    }))
  };
  handleSubmitEvaluate = () => {
    if (!this.props.unLock || this.props.isButtonForbid) {
      return;
    }
    this.props.setisLoading(true);
    const state = this.context.store.getState();
    const payload = getToEvaluateData(state.step.options, state.step.selected);
    this.props.toEvaluate(payload);
  };
  render (){
    const {
      propList, skus, keysOfOneList, unLock, isLoading,
      descList: { oneList, twoList, thrList } = {}
    } = this.props;
    const { open } = this.state;
    let index = 0;
    return <div className="mcycle-step-select">
      <Loading isLoading={isLoading} />
      {(propList || []).map(item =>
        <SelectRow {...item} isOpen={index === open} open={this.handleOpenPanel}
                   index={index} key={index++} type="props" />
      )}
      {(oneList || []).map((item, oneListIndex) =>
        <SelectRow {...item} isOpen={index === open} open={this.handleOpenPanel}
                   oneListIndex={oneListIndex} skus={skus} keysOfOneList={keysOfOneList}
                   index={index} key={index++} type="desc" />
      )}
      {(thrList || []).map(item =>
        <SelectRow {...item} isOpen={index === open} open={this.handleOpenPanel}
                   index={index} key={index++} type="desc" />
      )}
      {(twoList || []).map(item =>
        <SelectRow {...item} isOpen={index === open} open={this.handleOpenPanel}
                   index={index} key={index++} type="multi" />
      )}
      <div className="mcycle-step-select-submit">
        <Button type={unLock ? 'primary' : 'disabled'}
                size="large" onClick={this.handleSubmitEvaluate}>
          查看估值
        </Button>
      </div>
    </div>
  }
}

export default connect(
  state => ({
    isLoading: state.app.isLoading
  }),
  { setisLoading }
)(Select);



// WEBPACK FOOTER //
// ./src/components/step1/select/index.js